import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    title: {
        color: theme.palette.warning.main,
        margin: 0,
        textAlign: "left",
    },
}));
